// TOP LEVEL IMPORTS
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// APOLLO
import { graphql } from 'react-apollo';
import clientByIdQuery from 'ApolloClient/Queries/clientById';
import createContract1 from 'ApolloClient/Mutations/createContract1';
// COMPONENTS
import Modal from 'components/common/Modal';
import Row from 'components/common/Row';
import Button from 'components/common/Button';
import ActionLink from 'components/text/ActionLink';
import CreateContractForm from 'components/forms/CreateContractForm';

class CreateContractModal extends React.Component {
  state = {
    visible: false,
    loading: false,
  };

  toggleModal = () => {
    this.setState({ visible: !this.state.visible });
  };

  onSubmitHook = async contract => {
    this.setState({ loading: true });

    let response;

    let variables = {
      params: { ...contract },
    };

    let refetchQueries = [
      {
        query: clientByIdQuery,
        variables: { _id: this.props.clientId },
      },
    ];

    try {
      response = await this.props.createContract1({
        variables,
        refetchQueries,
      });
    } catch (err) {
      return console.log(err);
    }

    this.setState({ loading: false });
    let contractId = response.data.createContract1._id;
    this.props.history.push(`/app/contract/draft/${contractId}`);
  };

  handleClick = evt => {
    evt.preventDefault();
    this.toggleModal();
  };

  render() {
    const { triggerType, clientId, buttonProps } = this.props;
    const { visible } = this.state;

    const text = 'NEW CONTRACT';

    const button = (
      <Button onClick={this.handleClick} {...buttonProps}>
        {text}
      </Button>
    );

    const anchor = (
      <ActionLink href="" onClick={this.handleClick}>
        {text}
      </ActionLink>
    );

    const trigger = triggerType === 'button' ? button : anchor;

    return (
      <React.Fragment>
        {trigger}
        <Modal
          title="Create a Contract"
          visible={visible}
          style={{ width: 275 }}
          onOk={() => console.log('close modal')}
          onCancel={this.toggleModal}
          footer={null}
        >
          <Row>
            <CreateContractForm
              loading={this.state.loading}
              clientId={clientId}
              btnLabel="Create Contract"
              onCancel={this.toggleModal}
              onSubmitHook={this.onSubmitHook}
            />
          </Row>
        </Modal>
      </React.Fragment>
    );
  }
}

CreateContractModal.propTypes = {
  clientId: PropTypes.string.isRequired,
  buttonProps: PropTypes.object, // eslint-disable-line
};

CreateContractModal.defaultProps = {
  buttonProps: {},
};

export default graphql(createContract1, { name: 'createContract1' })(withRouter(CreateContractModal));



// WEBPACK FOOTER //
// ./src/components/common/CreateContractModal/index.js